<template>
<div>
    <article class="is-parent">
      <img :src="Team.logo" class="team_logo image is-96x96">
      <h1 class="title has-text-centered">{{Team.name}}</h1>

      <div class="columns">
        <div class="column is-6">
          <div class="segment">
          <!--<playerTable :headings="['#','','']" heading="Forwards" :tableData="forwards" redirect="/season-stats/player-stats/"></playerTable>-->
          <player-card :playerData="forwards" heading="Forwards" redirect="/season-stats/player-stats/" :logo="Team.logo"></player-card>
          </div>
        </div>
        <div class="column is-4">
          <div class="segment">
          <player-card :playerData="defense" heading="Defense" redirect="/season-stats/player-stats/" :logo="Team.logo"></player-card>
          </div>
          <div class="segment">
          <player-card :playerData="goaltending" heading="Goaltending" redirect="/season-stats/player-stats/" :logo="Team.logo"></player-card>
          </div>
        </div>
      </div>
    </article>
</div>
</template>
<script>
import _ from 'lodash'
import playerTable from '../stats/playerTable.vue'
import playerCard from '../stats/playerCard.vue'
export default {
  name: 'players',
  components: {
    'playerTable': playerTable,
    'player-card': playerCard
  },
  data () {
    return {
      Players: [],
      Team: []
    }
  },
  computed: {
    forwards () {
      let cleanData = []
      _.map(this.Players, function (object) {
        if (object.number > 0) {
          if (object.position === 'LW' || object.position === 'C' || object.position === 'RW') {
            cleanData.push(_.pick(object, ['id', 'number', 'forename', 'surname']))
          }
        }
      })
      cleanData = _.orderBy(cleanData, 'number', ['asc'])
      return cleanData
    },
    defense () {
      let cleanData = []
      _.map(this.Players, function (object) {
        if (object.number > 0) {
          if (object.position === 'LD' || object.position === 'RD') {
            cleanData.push(_.pick(object, ['id', 'number', 'forename', 'surname']))
          }
        }
      })
      cleanData = _.orderBy(cleanData, 'number', ['asc'])
      return cleanData
    },
    goaltending () {
      let cleanData = []
      _.map(this.Players, function (object) {
        if (object.number > 0) {
          if (object.position === 'GT' || object.position === 'BKUPGT' || object.position === 'EMRGGT') {
            cleanData.push(_.pick(object, ['id', 'number', 'forename', 'surname']))
          }
        }
      })
      cleanData = _.orderBy(cleanData, 'number', ['asc'])
      return cleanData
    }
  },
  methods: {
    fetchPlayers () {
      this.$http.get('https://devilsapi.roblutken.com/api/players/get/teams/' + this.$route.params.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Players = response.data
      }, response => {
      })
    },
    fetchTeam () {
      this.$http.get('https://devilsapi.roblutken.com/api/teams/get/' + this.$route.params.teamId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Team = response.data
        console.log(JSON.stringify(this.Team))
      }, response => {
      })
    },
    openReport (id) {
      this.$router.push('/season-stats/player-stats/' + id)
    }
  },
  created: function () {
    this.fetchPlayers()
    this.fetchTeam()
  },
  update: function () {
    this.fetchPlayers()
    this.fetchTeam()
  }
}
</script>
<style scoped lang="scss">
@import '~bulma/sass/utilities/mixins';
.team_logo {
  width: 62px;
  height: 62px;
  border-radius: 50%;
  display: block;
  margin-left: auto;
  margin-right: auto;

}
.player_logo {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
</style>

  <!--
    <div class="container has-text-centered">
        <article class="is-parent title">
            <img :src="Team.logo" class="team_logo image is-96x96">
            <p class="title">{{Team.name}}</p>
        </article>
   
     <div class="container is-child has-text-centered">
        <div class="columns is-vcentered">
          <div class="segment">
          <div class="column is-half">
          <table class="table is-narrow is-stripped">
            <thead>
              <th></th>
              <th>#</th>
              <th>Name</th>
            </thead>
            <tbody>
              <tr v-for="player in Players" :key="player.id" @click="openReport(player.id)">
                <div v-if=""
                <img class="player_logo image is-96x96" :src='player.picture'>
                <td>{{player.number}}</td>
                <td> {{player.forename}} {{player.surname}}</td>
              </tr>
            </tbody>
          </table>
          </div>
          </div>
<!--
    <div  v-for="i in Players.length">
    
        <span v-for="player in Players.slice((i - 1), i)">
            <div class="column"> 
             <article class="is-child box" @click="openReport(player.id)" >
                <img class="team_logo image is-96x96" :src='player.picture'>
                <p class="title" style="margin-top:20px;">{{player.number}}</p>
                <p class="">{{player.forename}}</p>
                <p class="">{{player.surname}}</p>
             </article>
            </div>
        </span>
        </div>
    
    </div>
    </div>
     </div>
</div>
</template>
-->



// WEBPACK FOOTER //
// players.vue?6ef5c6bc